import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TabPage } from './pages/TabPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { PricingPage } from './pages/PricingPage';
import { PricingContactPage } from './pages/PricingContactPage';
import { FaqPage } from './pages/FaqPage';
import { AnswerPage } from './pages/AnswerPage';
import { WhatIsDiDeckPage } from './pages/WhatIsDiDeckPage';
import { ScrollToTop } from './components/ScrollToTop';

/**
 * DI Deck website root. Uses two dynamic routes (/:slug and /:slug/ask)
 * to serve every tab detail page + its per-tab AI-search placeholder,
 * instead of registering fourteen literal routes inside `<Routes>`.
 *
 * Why this shape: React Router v6's `<Routes>` walks its children via
 * React.Children — mapping an array of `<Route>` elements inline works
 * in dev but the first Sprint 1 production build silently dropped the
 * generated routes (only literal-path routes survived). Collapsing to
 * one `/:slug` route sidesteps that class of issue and keeps App.tsx
 * shorter.
 */
export function App(): JSX.Element {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />

      {/* Literal paths first — React Router v6 ranks static segments
          above dynamic ones regardless of order, but keeping literals
          first makes the file legible. */}
      <Route path="/what-is-dideck" element={<WhatIsDiDeckPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/pricing/contact" element={<PricingContactPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/ask" element={<AnswerPage />} />
      <Route
        path="/investors"
        element={
          <ComingSoonPage
            title="Investors"
            sprint="Sprint 3 · Investors page"
            body="Investor materials will live here. Investor inbound is high-intent + low-volume, so this page is intentionally sparse."
          />
        }
      />
      <Route
        path="/legal/privacy"
        element={<ComingSoonPage title="Privacy" sprint="Legal docs pending" />}
      />
      <Route
        path="/legal/terms"
        element={<ComingSoonPage title="Terms of Service" sprint="Legal docs pending" />}
      />
      <Route
        path="/legal/dpa"
        element={<ComingSoonPage title="Data Processing Addendum" sprint="Legal docs pending" />}
      />

      {/* Dynamic tab routes — one per tab, plus its per-tab AI search. */}
      <Route path="/:slug" element={<TabPage />} />
      <Route path="/:slug/ask" element={<AnswerPage />} />

      <Route path="*" element={<HomePage />} />
      </Routes>
    </>
  );
}

